// hooks/maintenance/useMaintenanceHistory.js

import { useQuery } from "@tanstack/react-query";
import { fetchMaintenanceHistory } from "../../api/maintenance/maintenanceHistoryService"; // Asegúrate de que la ruta sea correcta

/**
 * Hook para obtener el historial de eventos de un mantenimiento específico.
 * @param {number} manId - El ID del mantenimiento para el cual se quiere el historial.
 * @returns {Object} Contiene los datos del historial, estado de carga y error.
 */
export const useMaintenanceHistory = (manId) => {
    // La queryKey será específica para el historial de un mantenimiento
    const queryKey = ["maintenanceHistory", manId];
    const queryFn = () => fetchMaintenanceHistory(manId);

    const {
        data: maintenanceHistory = [], // Valor por defecto para asegurar que 'data' sea siempre un array
        error,
        isLoading,
        isFetching,
    } = useQuery({
        queryKey: queryKey,
        queryFn: queryFn,
        enabled: !!manId, // La consulta solo se activa si manId es válido
        staleTime: 1000 * 60 * 5, // El historial puede ser "stale" por un tiempo más largo
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

    return {
        maintenanceHistory,
        isLoading,
        isFetching,
        error,
    };
};